import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { focusStyle } from '../styles/mixins';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    '&.Mui-focusVisible': {
      ...focusStyle(theme),
    },
  },
}), { name: 'CustomButton', index: StylesIndexInjections.UI_ATOMS });
